<footer class="footer d-none">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © Afaq.
            </div>
            <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by Afaq Developer
                </div>
            </div>
        </div>
    </div>
</footer>